export default __webpack_public_path__ + "static/media/card.da2a295f.svg";